/**
 * DeleteCommand.js
 * Nesne silme undo/redo komutu.
 *
 * Silinen Three.js nesneleri dispose edilmez — komut geçmişinde referans olarak tutulur.
 * Undo: nesneleri sahneye geri ekler.
 * Redo: nesneleri sahneden kaldırır.
 */

import BaseCommand from './BaseCommand';

class DeleteCommand extends BaseCommand {
  constructor(objects) {
    super('DELETE_OBJECTS', { before: null, after: null });
    // Dispose çağrılmadığı için nesneler hafızada canlı kalır
    this._objects = objects;
  }

  execute(scene, dispatch) {
    // Redo: sahneden kaldır
    this._objects.forEach(obj => {
      if (obj.parent) obj.parent.remove(obj);
      else scene.remove(obj);
    });
  }

  undo(scene, dispatch) {
    // Undo: sahneye geri ekle
    this._objects.forEach(obj => {
      if (!obj.parent) scene.add(obj);
    });
  }
}

export default DeleteCommand;
